import { render, staticRenderFns } from "./LawMatterSubjectList.vue?vue&type=template&id=53cbe990&"
import script from "./LawMatterSubjectList.vue?vue&type=script&lang=js&"
export * from "./LawMatterSubjectList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterSubjectList.vue?vue&type=style&index=0&id=53cbe990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports